<template>
    <v-navigation-drawer fixed permanent right>
        <v-container class="pa-5">
            <template v-if="tabs.main && !selectedColumn.status">
                <h3>Builder Tools</h3>

                <v-divider class="mb-5"></v-divider>
                <v-row>
                    <v-col cols="6"  class="pa-2">
                        <div class="tool-item" @click="openLayoutSelection">
                            <i class='bx bxs-customize bxs-tada-hover'></i>
                            <span>LAYOUT</span>
                        </div>
                    </v-col>
                    <v-col cols="6"  class="pa-2">
                        <div class="tool-item" @click="changeTab('banner')">
                            <i class='bx bx-chalkboard bx-tada-hover'></i>
                            <span>BANNER</span>
                        </div>
                    </v-col>
                    <v-col cols="6"  class="pa-2">
                        <!-- <div class="tool-item" @click="emitNewElement('grids', 3)"> -->
                        <div class="tool-item" @click="dialogs.grid.show = true">
                            <i class='bx bx-columns' ></i>
                            <span>GRIDS</span>
                        </div>
                    </v-col>

                    <v-col cols="12">
                        <v-divider class="mb-5"></v-divider>
                        <v-btn color="success" id="saveElementsBtn" block dense @click="$emit('saveElements')">Save Builder</v-btn>
                        <v-btn color="warning" @click="recover" block dense>Recover Last</v-btn>
                        <v-btn color="error" block dense @click="clearData = true">Clear All</v-btn>

                        <v-btn @click="toPreview" color="primary" block dense class="mt-15">Preview</v-btn>
                    </v-col>
                </v-row>
            </template>

            <template v-if="!tabs.main && tabs.banner.show">
                <h3>Add Banner</h3>
                <v-divider class="mb-5"></v-divider>
                <form @submit.prevent="addBanner">
                    <v-label>Select Type</v-label>
                    <v-select required name="type" v-model="tabs.banner.type" solo dense :items="['Image', 'Text']" label="Select Type"></v-select>
                    <v-label>Upload Image</v-label>
                    <v-text-field dense outlined placeholder="Image URL or Link..." name="image"></v-text-field>

                    <v-btn dense color="error" class="mr-2" @click="changeTab('main', 'banner')">Cancel</v-btn>
                    <v-btn dense color="primary" type="submit">Confirm</v-btn>
                </form>
            </template>

            <template v-if="selectedColumn.status">
                <h3 class="text-center">Grid Settings</h3>
                <v-divider class="mb-5"></v-divider>
                <v-row>
                    <v-col cols="6"  class="pa-2">
                        <div class="tool-item" @click="$emit('columnElement', 'heading1')">
                            <i class='bx bx-heading bx-tada-hover'></i>
                            <span>HEADING 1</span>
                        </div>
                    </v-col>
                    <v-col cols="6"  class="pa-2">
                        <div class="tool-item" @click="$emit('columnElement', 'heading2')">
                            <i class='bx bx-heading bx-tada-hover' ></i>
                            <span>HEADING 2</span>
                        </div>
                    </v-col>
                    <v-col cols="6"  class="pa-2">
                        <div class="tool-item" @click="$emit('columnElement', 'text')">
                            <i class='bx bx-font bx-tada-hover'></i>
                            <span>TEXT</span>
                        </div>
                    </v-col>
                    <v-col cols="6"  class="pa-2">
                        <div class="tool-item" @click="emitImageElement('column')">
                            <i class='bx bx-image-alt bx-tada-hover'></i>
                            <span>IMAGE</span>
                        </div>
                    </v-col>
                    <v-col cols="6" class="pa-2">
                        <div class="tool-item" @click="$emit('columnElement', 'dialog')">
                            <i class='bx bxs-message-rounded-dots bx-tada-hover'></i>
                            <span>Dialog</span>
                        </div>
                    </v-col>
                    <v-col cols="6"  class="pa-2">
                        <div class="tool-item" @click="$emit('columnElement', 'textcard')">
                            <i class='bx bxs-file-txt bx-tada-hover'></i>
                            <span>TEXTCARD</span>
                        </div>
                    </v-col>
                    <v-col cols="6"  class="pa-2">
                        <div class="tool-item" @click="$emit('columnElement', 'imagecard')">
                            <i class='bx bxs-book bx-tada-hover'></i>
                            <span>imagecard</span>
                        </div>
                    </v-col>
                    <v-col cols="6" class="pa-2">
                        <div class="tool-item" :class="$store.state.layout == 'BEDA' ? '' : 'disabled'" @click="$emit('columnElement', 'imagecard2')">
                            <i class='bx bx-book-alt bx-tada-hover'></i>
                            <span>imagecard 2</span>
                        </div>
                    </v-col>
                    <v-col cols="6"  class="pa-2">
                        <div class="tool-item" @click="$emit('columnElement', 'dropdown')">
                            <i class='bx bxs-caret-down-square bx-tada-hover'></i>
                            <span>dropdown</span>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card outlined class="pa-1 text-center font-weight-bold" @click="dialogs.gridSettings.show = true">
                            <i class="bx bxs-cog"></i> SETTINGS
                        </v-card>
                    </v-col>
                </v-row>
                <v-btn dense block color="error" class="mt-5" @click="exitGridTool">Close</v-btn>
            </template>

            <v-dialog width="300" v-model="dialogs.grid.show">
                <v-card class="pa-5 text-center">
                    <h3 class="blue--text mb-3">Grid Columns</h3>
                    <div class="px-5">
                        <v-text-field
                            type="number"
                            dense
                            label="Columns"
                            placeholder="Placeholder"
                            outlined
                            v-model="dialogs.grid.columns"
                        ></v-text-field>
                    </div>
                    <v-btn dense color="error" class="mr-2" @click="dialogs.grid.show = false">Cancel</v-btn>
                    <v-btn dense color="primary" @click="addGrid">Confirm</v-btn>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogs.gridImageUploader" max-width="400">
                <v-card class="pa-5 text-center">
                    <h3 class="blue--text mb-3">Add Image To Grid</h3>
                    <form @submit.prevent="uploadImage('column')">
                        <v-row class="pa-5">
                            <input type="file" id="imageForGrid">
                        </v-row>
                        <v-row class="pa-2">
                            <v-col cols="6">
                                <v-text-field dense outlined label="Width (px)" name="width"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field dense outlined label="Height (px)" name="height"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-btn dense color="error" class="mr-2" @click="dialogs.gridImageUploader = false">cancel</v-btn>
                            <v-btn dense color="primary" class="mr-2" type="submit">Upload</v-btn>
                        </v-row>
                    </form>
                </v-card>
            </v-dialog>

            <v-dialog v-model="clearData" width="500">
                <v-card class="pa-5">
                    <h3 class="red--text">Warning!</h3>
                    <span>Are you sure that you want to reset the data?
                        <br />This will clear all of the unsaved elements that you have worked on.
                    </span>
                    <div class="mt-5">
                        <v-btn dense color="primary" class="mr-1" small @click="clearData = false">Cancel</v-btn>
                        <v-btn dense color="error" small @click="resetData">Reset Data</v-btn>
                    </div>
                </v-card>
            </v-dialog>

            <!-- for style selection -->
            <v-dialog :persistent="layout == null" v-model="layoutSelectionModal" width="90%">
                <v-card class="pa-5">
                    <h2 class="blue--text text-center mb-5">Select Layout</h2>
                    <v-row>
                        <v-col v-for="(layout, layoutIndex) in builderLayout.selection" :key="layoutIndex"
                            cols="3" style="margin-bottom: -15px;"
                        >
                            <v-card outlined :class="checkIfLayoutIsCurrent(layout.code)"
                                @click="selectLayout(layout.code)"
                            >
                                {{ layout.name }}
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-btn dense color="primary" class="ma-5" :disabled="builderLayout.submit" @click="updateLayout">Confirm Layout</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogs.gridSettings.show" width="30%" scrollable>
                <v-card class="pa-5">
                    <h3 class="blue--text text-center mb-5"><i class="bx bxs-cog"></i> Grid Settings</h3>
                    <v-container class="column-settings">
                        <form @submit.prevent="emitGridSettings">
                            <!-- background here -->
                            <div class="text-center mb-3">
                                <div class="font-weight-bold">Background</div>
                                <div class="subtitle-2 font-italic">If background color has a value, gradients will be ignored.</div>
                            </div>
                            <v-row class="mb-2">
                                <v-col cols="4">
                                    <div name="test"></div>
                                    <label>Background</label> <br />
                                    <input type="color" :value="checkStyleValue('background')" @change="inputValueChanged('background')">
                                </v-col>
                                <v-col cols="8">
                                    <div class="text-center">Gradient Background</div>
                                    <v-row>
                                        <v-col cols="6">
                                            <input type="color" :value="checkStyleValue('gradientBg1')" @change="inputValueChanged('gradientBg1')">
                                        </v-col>
                                        <v-col cols="6">
                                            <input type="color" :value="checkStyleValue('gradientBg2')" @change="inputValueChanged('gradientBg2')">
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <hr />
                            </v-row>
                            <hr />

                            <!-- border here  -->
                            <div class="text-center ma-3">
                                <div class="font-weight-bold">Border </div>
                            </div>
                            <v-row class="mb-2">
                                <v-col cols="6">
                                    <label>Border Color</label> <br />
                                    <input type="color" :value="checkStyleValue('borderColor')" @change="inputValueChanged('borderColor')">
                                </v-col>
                                <v-col cols="6">
                                    <label>Border Size (px)</label>
                                    <input type="text" :value="checkStyleValue('borderWidth')" @change="inputValueChanged('borderWidth')">
                                </v-col>
                            </v-row>
                            <hr />

                            <!-- margin here and padding here  -->
                            <div class="text-center ma-3">
                                <div class="font-weight-bold">Margin and Padding</div>
                            </div>
                            <v-row>
                                <v-col cols="6">
                                    <label>Margin (px)</label> <br />
                                    <input type="text" :value="checkStyleValue('margin')" @change="inputValueChanged('margin')">
                                </v-col>
                                <v-col cols="6">
                                    <label>Padding (px)</label>
                                    <input type="text" :value="checkStyleValue('padding')" @change="inputValueChanged('padding')">
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4">
                                    <label>Text Alignment</label>
                                    <select @change="inputValueChanged('textAlignment')">
                                        <option value="text-left">Left</option>
                                        <option value="text-center">Center</option>
                                        <option value="text-right">Right</option>
                                    </select>
                                </v-col>
                                <v-col cols="4">
                                    <label>Font Color</label>
                                    <input type="color" :value="checkStyleValue('textColor')" @change="inputValueChanged('textColor')">
                                </v-col>
                                <v-col cols="4">
                                    <label>Heading Color</label>
                                    <input type="color" :value="checkStyleValue('headingColor')" @change="inputValueChanged('headingColor')">
                                </v-col>
                            </v-row>
                            <v-row justify="center" class="mt-5">
                                <v-btn color="error" class="mr-2" @click="dialogs.gridSettings.show = false">Cancel</v-btn>
                                <v-btn color="primary" type="submit">update</v-btn>
                            </v-row>
                        </form>
                    </v-container>
                </v-card>
            </v-dialog>

        </v-container>
    </v-navigation-drawer>
</template>

<script>
import axios from "axios"
import { bus } from "@/main"

export default {
    // props: ["unitLayout"],
    data () {
        return {
            tabs: {
                main: true,
                banner: {
                    show: false,
                    type: null
                },
                column: {
                    show: false
                },
                image: {
                    type: null
                }
            },
            dialogs: {
                grid: {
                    show: false,
                    columns: 0
                },
                gridSettings: {
                    show: false,
                    picker: null
                },
                gridImageUploader: false
            },
            selectedColumn: {
                status: false,
                styles: null
            },
            imageSubmit: false,
            saveBtnDisable: false,
            clearData: false,
            layoutSelectionModal: false,
            builderLayout: {
                submit: false,
                selected: null,
                selection: [
                    { name: "Business Dialogues One", code: "BD1" },
                    { name: "Business English Discussion & Analysis", code: "BEDA" },
                    { name: "Business English Situational Dialogues", code: "BESD2" },
                    { name: "Business Process Emailing", code: "BPE" },
                    { name: "Business Process Meeting", code: "BPM" },
                    { name: "Business Process Negotiation", code: "BPN" },
                    { name: "Business Process Presentation", code: "BPP" },
                    { name: "Cabin Crew", code: "CC" },
                    { name: "Conversation Junior Basic", code: "CJB2" },
                    { name: "Conversation Junior Intermediate", code: "CJI2" },
                    { name: "Conversation Junior Advanced", code: "CJA2" },
                    { name: "Daily Dialogue One", code: "DD1" },
                    // { name: 'Debate One', code: 'D1' },
                    { name: "First Step in Conversation 1", code: "FSIC1" },
                    { name: "FreeTalking Debate", code: "FTDebate" },
                    { name: "FreeTalking Description", code: "FTDescription" },
                    { name: "FreeTalking Q & A", code: "FTQA" },
                    { name: "Global Medical English", code: "GME" },
                    { name: "Grammar In Pattern Basic", code: "GIPB" },
                    { name: "Hotel Dialogues One", code: "HD1" },
                    { name: "Interview English", code: "IE" },
                    { name: "IELTS One", code: "IELTS1" },
                    { name: "Milestone", code: "Milestone1" },
                    { name: "Pattern Practice Junior Basic", code: "PPJB" },
                    { name: "Pattern Practice Junior Intermediate", code: "PPJI" },
                    { name: "Pattern Practice Junior Advanced", code: "PPJA" },
                    { name: "Phonics One", code: "PH1" },
                    { name: "Phonics Two", code: "PH2" },
                    { name: "Phonics Three", code: "PH3" },
                    { name: "Phonics Four", code: "PH4" },
                    { name: "Phonics Five", code: "PH5" },
                    { name: "Phonics Six", code: "PH6" },
                    { name: "Speaking Pattern", code: "SP" },
                    { name: "Travel English", code: "TE" },
                    { name: "Perfect Reading 1", code: "PRT1" },
                    { name: "Perfect Reading 2", code: "PRT2" }
                ]
            }
        }
    },

    watch: {
        // unitLayout () {
        //     this.layoutSelectionModal = this.unitLayout == null
        //     this.builderLayout.selected = this.unitLayout
        // }
    },

    created () {
        bus.$on("clickedColumn", styles => {
            this.selectedColumn.status = true
            this.selectedColumn.styles = styles
        })
    },

    methods:
    {
        // computed
        checkIfLayoutIsCurrent (layoutCode) {
            return this.layout == layoutCode ? "pa-3 selection current" : "pa-3 selection"
        },

        // end of computed

        checkStyleValue (key) {
            if (this.selectedColumn.styles != null) {
                const colors = ["background", "gradientBg1", "gradientBg2", "borderColor", "textColor", "headingColor"]
                const values = ["borderWidth", "padding", "margin"]
                if (colors.includes(key) && this.selectedColumn.styles[key] == "") {
                    return "#FfFfFf"
                }
                else if (values.includes(key) && this.selectedColumn.styles[key] != "") {
                    return "0"
                }
                else {
                    return this.selectedColumn.styles[key]
                }
            }
        },

        inputValueChanged (key) {
            this.selectedColumn.styles[key] = event.target.value
        },

        emitNewElement (type, val = "", data = null) {
            this.$emit("newElement", type, val, data)
        },

        emitGridSettings () {
            this.$emit("gridSettings", this.selectedColumn.styles)
            this.dialogs.gridSettings.show = false
        },

        saveElementsToDb () {
            this.$emit("saveElements")
        },

        openLayoutSelection () {
            this.layoutSelectionModal = true
        },

        recover () {
            const storage = localStorage.getItem("meobuilder-elements-backup")
            const backup = JSON.parse(storage)
            backup == null ? "" : this.$store.dispatch("updateElements", backup)
        },

        emitImageElement (imageType) {
            imageType == "column" ? this.$emit("columnElement", "image", null) : this.emitNewElement("image")
        },

        uploadImage (imageType) {
            const btn = event.submitter.classList
            btn.remove("primary")
            btn.add("submitted-button")

            const { height, width } = Object.fromEntries(new FormData(event.target))
            const formData = new FormData()
            const file = document.getElementById("imageForGrid").files[0]

            formData.append("image", file)

            axios.post("/cms/upload-image-for-builder", formData)
                .then(res => {
                    const data = {
                        image: res.data,
                        height,
                        width
                    }
                    imageType == "column" ? this.$emit("columnElement", "image", data) : this.emitNewElement("image", data)
                })
                .catch(err => console.log(err))

            btn.remove("submitted-button")
            btn.add("primary")

            this.dialogs.gridImageUploader = false
        },

        disableToolArrayCheck (array) {
            return array.includes(this.layout) ? "" : "disabled"
        },

        selectLayout (layout) {
            this.builderLayout.selected = layout
        },

        updateLayout () {
            this.builderLayout.submit = true
            axios.patch(`cms/v1/textbook/unit/${this.$route.query.unit}`, { style: this.builderLayout.selected })
                .then(() => {
                    window.location.reload()
                })
                .catch(err => {
                    console.log(err)
                })

            this.builderLayout.submit = false
            this.layoutSelectionModal = false
        },

        exitGridTool () {
            this.$emit("newElement", "close")
            this.selectedColumn.status = false
        },

        changeTab (tab, from = null, imageType) {
            if (tab == "main") {
                this.tabs[from].show = false
                this.tabs.main = true
            }
            else {
                this.tabs.main = false
                this.tabs[tab].show = true

                this.tabs.image.type = imageType
            }
        },

        emitCard () {
            const { type, columns } = Object.fromEntries(new FormData(event.target))
            this.emitNewElement(type, parseInt(columns))

            this.changeTab("main", "cards")
        },

        updateElements () {
            this.$store.dispatch("updateElements", "this is the payload")
        },

        addGrid () {
            this.emitNewElement("grids", this.dialogs.grid.columns)
            this.dialogs.grid.show = false
        },

        async addBanner () {
            const type = this.tabs.banner.type.toLowerCase()

            let data
            if (type == "image") {
                const { image } = Object.fromEntries(new FormData(event.target))
                data = image
            }
            else if (type == "text") {
                data = "Banner heading text here."
            }

            this.emitNewElement("banner", type, data)

            this.changeTab("main", "banner")
        },

        resetData () {
            this.$store.dispatch("updateElements", [])
            this.clearData = false
        },

        toPreview () {
            const url = window.location.href
            const previewUrl = url.replace("canvas", "preview")

            window.open(previewUrl)
        }
    }
}
</script>

<style scoped>
    button {
        margin-bottom: 5px;
    }

    .bottom-buttons {
        position: fixed;
        bottom: 0;
        margin-bottom: 20px;
        width: 100%;
        max-width: 220px;
    }

    .submitted-button {
        opacity: 0.5;
        pointer-events: none;
    }

    .selection {
        cursor: pointer;
        transition: 0.3s ease-in-out;
    }

    .selection:hover {
        background: rgb(236, 236, 236);
    }

    .selection.current {
        border: 1px solid green !important;
        background: rgb(210, 255, 210);
        color: green;
        pointer-events: none;
        cursor: auto;
    }

    .selection.selected {
        border: 1px solid #1389ce;
        background: #d1eafa;
        color: #086da8;
    }

</style>
